import Breadcrumb from '@carvana/ds-breadcrumb';
import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import Actions, { ActionsLocations } from '@/vdp/Actions';
import ShowConditionally from '@/vdp/VehicleDetailsContainer/ShowConditionally';
import { SectionName } from '~/constants/vdp/section';
import { useIsMobile, useIsNative } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/vdp/GlobalContext';
import { SectionAnalyticsProvider } from '~/context/vdp/SectionAnalyticsContext';
import { useParentModelBreadcrumbs } from '~/hooks/vdp';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import useIsInMiniHeroExperiment from '~/hooks/vdp/useIsInMiniHeroExperiment';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { Wrapper } from './BreadCrumbs.styles';

function BreadCrumbs() {
  const breadCrumbs = useParentModelBreadcrumbs();
  const isMobile = useIsMobile();
  const { setIsBreadcrumbScrolledOut } = useContext(GlobalContext);

  const [ref, inView] = useInView({
    threshold: [0, 1]
  });

  useEffect(() => {
    if (!isMobile) {
      setIsBreadcrumbScrolledOut(!inView);
    }
  }, [inView, isMobile, setIsBreadcrumbScrolledOut]);

  return (
    <div ref={ref}>
      <Breadcrumb
        backIcon={false}
        classes={{
          container: 'whitespace-pre',
          link: 'text-text-weak hover:text-text-weak'
        }}
        crumbs={breadCrumbs}
        size="sm"
      />
    </div>
  );
}

function BreadCrumbsWrapper() {
  const isInMiniHeroExperiment = useIsInMiniHeroExperiment();
  const isNative = useIsNative();
  const { isSold, otherUnavailable, unavailable } = useAlertStatus();

  if (isNative) return null;

  const hideActions =
    isInMiniHeroExperiment && (isSold || unavailable || otherUnavailable);

  return (
    <SectionAnalyticsProvider analyticsId={SectionName.Hero}>
      <Wrapper>
        <BreadCrumbs />
        {!hideActions && (
          <ShowConditionally native={false}>
            <Actions location={ActionsLocations.BreadCrumb} size="xxs" />
          </ShowConditionally>
        )}
      </Wrapper>
    </SectionAnalyticsProvider>
  );
}

export default withErrorBoundary(BreadCrumbsWrapper);
